import React from 'react'
import { Col, Row } from 'antd'

import { Title } from 'src/components/Ant'

export default function UserBasicTitle() {
  return (
    <Row gutter={24}>
      <Col span={24}>
        <Title level={4} title="web.user.common.required_data" />
      </Col>
    </Row>
  )
}
